import InvalidRolesPage from './InvalidRolesPage';

export default InvalidRolesPage;